import React from 'react'
import './Reels_Counter_Exp.css'
import { FaCheck } from 'react-icons/fa';

const Counter_Exp = () => {
  return (
    <div class="section harsafe-service-section-04 harsafe-service-section-07 section-padding">
            <div class="container">
                {/* <!-- Service Wrap Start --> */}
                <div class="service-wrap">
                    <div class="section-title text-center">
                        <h3 class="sub-title color-3">Harsafe Meet Reels Solutions</h3>
                        <h2 class="title">Highly Tailored Harsafe Reels &amp; Support Services. </h2>
                    </div>
                    <div class="service-content-wrap">
                        <div class="row">
                            <div class="col-lg-6">
                                {/* <!-- Experience Wrap Start --> */}
                                <div class="experience-wrap">
                                    <img class="shape-1" src="assets/images/shape/experince-shape2.png" alt=""/>
                                    <div class="experience">
                                        <h3 class="number">2+</h3>
                                        <span>Years Experience Working</span>
                                    </div>
                                </div>
                                {/* <!-- Experience Wrap End --> */}
                            </div>
                            <div class="col-lg-6">
                                {/* <!-- Service Content Start --> */}
                                <div class="service-content">
                                    <p class="text">We’ll provide you with a comprehensive platform and dedicated support to enhance your content creation and sharing experience.</p>
                                    <div class="service-list">
                                        <ul>
                                            <li>
                                                <span class="service-icon"><FaCheck /></span>
                                                <span class="service-text">Create and share engaging videos with our intuitive interface designed for seamless creativity and collaboration.</span>
                                            </li>
                                            <li>
                                                <span class="service-icon"><FaCheck /></span>
                                                <span class="service-text"> Foster connections between creators and viewers through interactive features like comments, likes, and notifications.</span>
                                            </li>
                                            <li>
                                                <span class="service-icon"><FaCheck /></span>
                                                <span class="service-text">Leverage powerful analytics to track performance, understand trends, and grow your audience effectively.</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <!-- Service Content En --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Service Wrap End --> */}
            </div>
        </div>
  )
}

export default Counter_Exp